import React from 'react'
import LoginImg1 from '../../img/others/login-qr.png'
import LoginImg2 from '../../img/icons/google-longin.png'
import LoginImg3 from '../../img/icons/apple-login.png'
import Header from '../Header'
import Footer from '../Footer'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'

const Register = () => {
    return (
        <>
            <Header />
            <div class="login-page sp">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-6 m-auto">
                            <div class="login-bg">
                                <div class="heading1 text-center">
                                    <span class="span">Account create</span>
                                    <h2>Register to PayCoin</h2>
                                </div>

                                <div class="login-area">
                                    <h5>Create Your Account</h5>

                                    <div class="form-area">
                                        <form action="#">
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <div class="single-input">
                                                        <label>First Name</label>
                                                        <input type="text" placeholder="First Name" />
                                                    </div>
                                                </div>
                                                <div class="col-md-6">
                                                    <div class="single-input">
                                                        <label>Last Name</label>
                                                        <input type="text" placeholder="Last Name" />
                                                    </div>
                                                </div>
                                                <div class="col-md-6">
                                                    <div class="single-input">
                                                        <label>Email/Phone</label>
                                                        <input type="text" placeholder="Email/Phone" />
                                                    </div>
                                                </div>
                                                <div class="col-md-6">
                                                    <div class="single-input">
                                                        <label>UID Code</label>
                                                        <input type="text" placeholder="Please fill in the email form." />
                                                    </div>
                                                </div>
                                                <div class="col-md-6">
                                                    <div class="single-input">
                                                        <label>Country</label>
                                                        <select class="wide" style={{
                                                        padding: '18px',
                                                        borderRadius: '4px',
                                                        border: 'none',
                                                        width: '100%',
                                                        background: '#F3F4FF'
                                                    }}>
                                                            <option value="">England</option>
                                                            <option value="">Argentina</option>
                                                            <option value="">Brazil</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div class="col-md-6">
                                                    <div class="single-input">
                                                        <label>Phone Number</label>
                                                        <input type="number" placeholder="Phone Number" />
                                                    </div>
                                                </div>

                                                <div class="col-md-6">
                                                    <div class="single-input">
                                                        <label>Password</label>
                                                        <input type="password" placeholder="Password" />
                                                    </div>
                                                </div>
                                                <div class="col-md-6">
                                                    <div class="single-input">
                                                        <label>Confirm Password</label>
                                                        <input type="password" placeholder="Password Confirm" />
                                                    </div>
                                                </div>

                                                <div class="check-box-area">
                                                    <div class="box">
                                                        <input type="checkbox" id="vehicle1" name="vehicle1" value="Bike" /><label for="vehicle1"> Remember me</label>
                                                    </div>
                                                    <div class="pera">
                                                        <a href="#">Forgot Password?</a>
                                                    </div>
                                                </div>
                                                <div class="google-buttons">
                                                    <a href="#" class="google-btn"><img src={LoginImg2} alt="" /> Sign In with Google</a>
                                                    <a href="#" class="google-btn"><img src={LoginImg3} alt="" /> Sign In with Google</a>
                                                </div>
                                                <div class="button">
                                                    <button class="theme-btn1 btn btn--ripple ripple">Pre-Registration <i class="fa-solid fa-arrow-right"></i></button>
                                                </div>

                                                <div class="qr-code-area">
                                                    <p>Already Have An Account? <a href="/login">Login</a><br /> mobile app to log in instantly.</p>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}

export default Register